<template>
    <div v-if="getShowModalMessage" class="modal-window">
        <div v-if="ticked">{{tick()}}</div>
        <div class="modal card-border-style border-radius-md">
            <v-card class="background-transparent shadow-none">
                <v-card-title> {{getShowModalMessage.type}}</v-card-title>
                <v-card-text>
                    <div>                        
                        <div v-html="getShowModalMessage.content"></div>
                        <p></p>
                        <div v-if="getShowModalMessage.input && getShowModalMessage.input == 1">
                            <v-text-field
                                v-model = "myText"
                                ref="d"
                                >
                            </v-text-field>
                        </div>
                        <div v-if="getShowModalMessage.buttons && getShowModalMessage.buttons.length>0">
                            <v-btn v-for="(item, index) in getShowModalMessage.buttons" :key="index"
                                @click.native="close(item.value)"
                                class="btn-style btn-primary">
                                {{item.text}}
                                </v-btn>
                        </div>
                        <div v-if="getShowModalMessage.icons && getShowModalMessage.icons.length>0">
                            <v-icon v-for="(item, index) in getShowModalMessage.icons" :key="index"
                                @click="close(item.value)" :color="item.color">
                                {{item.text}}
                                </v-icon>
                        </div>

                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>


<script>
import {mapGetters} from 'vuex'
// import * as logs from '../../assets/log_process.js'

export default {
    data() {
        return {
            myText : '',
            ticked : true
        }
    },
    computed: 
        mapGetters([
                    'getShowModalMessage'
                ])
    ,
    props: {
        content: String
    },
    methods: {
        close(value) {
            this.$store.commit('setShowModalMessage',null) 
            this.$store.commit('setShowModalMessageText',this.myText) 
            this.$store.commit('setShowModalMessageResult',value) 
            this.ticked = true
        },
        tick() {
            this.ticked = false
            if (this.getShowModalMessage.input && this.getShowModalMessage.input == 1)
                this.$nextTick(() => {
                    this.$refs.d.focus()
                })
            this.myText = ''
        }
    }
}

</script>

<style>
  .modal-window {
    position: fixed;
    top: 50px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 20;
    background-color: rgba(0, 0, 255, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;    
    min-width: 10%;
  }

</style>